import { Box, styled } from '@mui/material';

export const PaddingBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  paddingBottom: theme.spacing(6),
  paddingLeft: theme.spacing(2.5),
}));
